import { useEffect, useRef } from "react";
import { Pressable } from "react-native";
import { CheckBox as RNECheckBox, CheckBoxProps } from "react-native-elements";

function CheckBoxPressable(props: any) {
  // @ts-expect-error This should be correct, but isn't
  const ref = useRef<Pressable>();
  useEffect(() => {
    ref.current?.setNativeProps?.({
      "aria-checked": props.accessibilityState.checked,
      "aria-disabled": props.accessibilityState.disabled,
    });
  }, [
    props.accessibilityState.checked,
    props.accessibilityState.disabled,
    ref.current,
  ]);
  return <Pressable ref={ref} {...props} />;
}

export function CheckBox(props: CheckBoxProps) {
  // @ts-expect-error RNECheckBox type definitions don't seem to match
  return <RNECheckBox Component={CheckBoxPressable} {...props} />;
}
